import actions from './actions';
import getters from './getters'
import mutations from './mutations';


const getDefaultState = () => ({
  dashboards : [],
  loadingDashboards : false,
  outDated : true
});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
